// 테스트 api
// export const TEST_ADD = "http://192.168.1.241:9080";
export const TEST_ADD = "https://www.storrngo.kr:8443";

// 이미지 호출 api
// export const TEST_IMAGE = `http://192.168.1.241:9080/upload`;
export const TEST_IMAGE = "https://www.storrngo.kr:8443/upfiles";

// sns 연동 
export const TEST_SNS = "https://www.storrngo.co.kr:8443";